import { DivProps } from "types/dom";

type Props = DivProps & {
  text?: string
}
export default function YellowBox({ text, className, children, ...otherProps }: Props) {
  return <div className={`${className} px-6 py-4 border-2 border-yellow-500 bg-yellow-50 rounded-lg`} {...otherProps}>
    {text || children}
  </div>;
}